import { AuthService } from './auth.service';
import { TenantCustomizationService } from './tenant-customization.service';

export function appInitializer(
  authService: AuthService,
  tenantCustomizationService: TenantCustomizationService
) {
  return () =>
    new Promise((resolve) => {
      authService.init();
      tenantCustomizationService
        .getCustom()
        .toPromise()
        .then((suiteUserCustomization) => {
          localStorage.setItem('tenantId', suiteUserCustomization.id);
          tenantCustomizationService.updateTenantCustom(
            suiteUserCustomization.tenantCustomization
          );
        })
        .then(() => {
          authService
            .refreshToken()
            .toPromise()
            .then(function () {
              authService.getAuth().toPromise().then(resolve);
            })
            .catch(resolve);
        })
        .catch(resolve);
    });
}
